import { render, staticRenderFns } from "./TransbankComponent.vue?vue&type=template&id=9f542db0&"
import script from "./TransbankComponent.vue?vue&type=script&lang=js&"
export * from "./TransbankComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports